import { render, staticRenderFns } from "./crudPointsSales.vue?vue&type=template&id=28f13fa5&"
import script from "./crudPointsSales.vue?vue&type=script&lang=js&"
export * from "./crudPointsSales.vue?vue&type=script&lang=js&"
import style0 from "./crudPointsSales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports